// these values are currently included in the redux
// version of the payload but should not be needed
// for the reasons noted inline
export const entityWhitelistKeys = {
  items: true, // <-- not on swagger
  properties: true, // <-- not on swagger
  needsCustoms: true, // part of properties, not on swagger
  isInternational: true, // part of properties, not on swagger
  rate: true, // <-- not on swagger
  isReturn: true, // <-- not on swagger for saveconfigandrate
  shippingConfigurationHash: true, // <-- not on swagger
  carrierId: true, // <-- not on swagger
  dimensions: true, // <-- not on swagger
  weight: true, // <-- not on swagger
  reason: true, // <-- not on swagger
};

const shipToValidator = (context, redux) => {
  if (!context?.verificationMessage && !redux?.verificationMessage) {
    return true;
  }
  return false;
};

export const entityFalsyChecksOk = (key, contextValue, reduxValue) => {
  const nullIsOkForUndefined = {
    serviceId: true,
    sellerLabelProviderId: true,
    serviceCollectionGuid: true,
    deliveryEmailNotificationTemplateId: true,
    shipmentEmailNotificationTemplateId: true,
  };
  if (nullIsOkForUndefined[key] && contextValue === null && reduxValue === undefined) {
    return true;
  }

  if (key === 'verificationMessage' && contextValue === '' && reduxValue === null) {
    return true;
  }

  if (key === 'availableSellerShippingServices' && Array.isArray(contextValue) && !reduxValue) {
    return true;
  }

  if (key === 'shipTo') {
    return shipToValidator(contextValue, reduxValue);
  }
  return false;
};
